import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Table } from 'components/shared/Table/Table'
import { deadlineDay, zoneLabel } from 'utils/dates'

import styles from './DeadlineCell.module.scss'

export interface DeadlineCellProps {
  /** The day the recruiter chose, as `YYYY-MM-DD`. Never an instant. */
  deadlineDate?: string | null
  /** The IANA zone it was resolved in, named under the date. */
  deadlineTz?: string | null
  /** The server's answer to "can this candidate still act". */
  pastDeadline?: boolean | null
  hasIncreasedHeight?: boolean
}

export const DeadlineCell = ({
  deadlineDate,
  deadlineTz,
  pastDeadline = false,
  hasIncreasedHeight,
}: DeadlineCellProps) => {
  const day = deadlineDay(deadlineDate)
  const isExpired = Boolean(day) && Boolean(pastDeadline)
  const zone = zoneLabel(deadlineTz)

  return (
    <Table.Cell type="body" {...{ hasIncreasedHeight }}>
      <Box
        align="center"
        className={styles.content}
        direction="column"
        tagName="span"
      >
        <span className={styles.date}>{day ?? '-'}</span>
        {isExpired ? (
          <span className={styles.expired}>{t`expired`}</span>
        ) : zone ? (
          <span className={styles.zone}>{zone}</span>
        ) : null}
      </Box>
    </Table.Cell>
  )
}
